export default __webpack_public_path__ + "static/media/miso-banner.1d856135.jpg";